// local
import http from '$shared/http.js';
import { getBootstrapData } from '$shared/utils.js';

/**
 * @typedef {Object} Post
 * @property {number} id
 * @property {string} promo_photo
 * @property {string} published_at
 * @property {string} title
 * @property {string} url
 */

/**
 * @param {string} tagName
 * @param {string} className
 * @param {string} innerText
 * @returns {Element}
 */
function create(tagName, className, innerText) {
  const el = document.createElement(tagName);

  if (className) {
    el.className = className;
  }
  if (innerText) {
    el.innerText = innerText;
  }

  return el;
}

/**
 * @returns {number}
 */
function getPostId() {
  return getBootstrapData('post').id;
}

function hideChrome(/** @type {Element} */ el) {
  const allHideIfEmpty = el.parentElement.querySelectorAll('.hide-if-empty');

  allHideIfEmpty.forEach((d) => {
    d.style.display = 'none';
  });
}

/**
 * @param {Element} el
 * @param {Post[]} posts
 * @returns {Post[]}
 */
function slicePosts(/** @type {Element} */ el, posts) {
  const maxPostsString = el.getAttribute('data-max-posts');

  if (maxPostsString) {
    const maxPosts = parseInt(maxPostsString, 10);
    return posts.slice(0, maxPosts);
  } else {
    return posts;
  }
}

function zeroPad(/** @type {number} */ n) {
  return n.toString().padStart(2, '0');
}

function formatDate(/** @type {string | number} */ datestamp) {
  const thisDate = new Date(datestamp);
  const dateYear = thisDate.getFullYear();
  const dateMonth = thisDate.getMonth() + 1;
  const dateDay = thisDate.getDate();

  return `${zeroPad(dateMonth)}.${zeroPad(dateDay)}.${dateYear}`;
}

function template(
  /** @type {Element} */ el,
  /** @type {{posts: Post[]}} */ data
) {
  const postId = getPostId();
  const posts = data.posts;

  if (posts.length === 0) {
    hideChrome(el);
    return;
  }

  if (posts.length === 1 && posts[0].id === postId) {
    hideChrome(el);
    return;
  }

  const slicedPosts = slicePosts(
    el,
    posts.filter((post) => post.id !== postId)
  );

  slicedPosts.forEach((post) => {
    const li = create('li', 'item');
    const date = create('div', 'date');
    const dateSpan = create('span', '', formatDate(post.published_at));

    date.appendChild(dateSpan);
    li.appendChild(date);

    const headline = create('div', 'headline');
    const headlineA = create('a', '', post.title);
    headlineA.href = post.url;

    headline.appendChild(headlineA);
    li.appendChild(headline);
    el.appendChild(li);
  });
}

async function fetchData(/** @type {Element} */ el) {
  if (el.getAttribute('data-loaded') === 'true') {
    return;
  } else {
    el.setAttribute('data-loaded', 'true');
  }

  const path = el.getAttribute('data-path');
  const data = await http.get(path).json();

  template(el, data);
}

function setup() {
  document
    .querySelectorAll('[data-sidebar-v1],[data-sidebar-germany]')
    .forEach((element) => {
      fetchData(element);
    });
}

setup();
